<template>
  <div class="container">
    <div class="line">
      <p class="noData" v-if="!waterList.length">暂无数据</p>
      <div class="WaterSystem flex" v-for="(item, index) in waterList" :key="index" v-else>
        <div class="WaterSystemEchart" style="height:200px;width: 100%;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { waterSystemMonitorLine } from '@/api/report.js';

export default {
  props: ['cpNum'],
  data() {
    return {
      activeVar: 0,
      changeList: ['最高温度', '最高电压', '最高电流', '剩余电流'],
      chartLine: null,
      waterList: [], // 水系统数据列表
      waterTimer: [],
    };
  },
  watch: {
    cpNum(val) {
      this.getWaterList();
      this.waterList = val;
    },
  },
  mounted() {
    if (this.cpNum) this.getWaterList();
  },
  methods: {
    activeFun(item, index) {
      this.activeVar = index;
    },
    getWaterList() {
      waterSystemMonitorLine({ companyNum: this.cpNum }).then((res) => {
        // log(res, "水系统检测列表数据");
        this.waterList = res.data;
        this.waterTimer = this.waterList.map((item) => {
          return Object.values(item.info).map((item2) => item2.time);
        });

        // log(this.waterTimer); // []
        setTimeout(() => {
          this.drawWaterSystemEchart(this.waterTimer);
        }, 200);
      });
    },
    drawWaterSystemEchart(waterTimer) {
      var waterSystemMonitorLineChart = document.getElementsByClassName('WaterSystemEchart'); //获取类名
      for (var i = 0; i < this.waterList.length; i++) {
        var myWaterSystemMonitorLineChart = this.$echarts.init(waterSystemMonitorLineChart[i]);
        if (this.waterList.length) {
          var optoins = {
            title: {
              subtext: this.waterList[i].name,
            },
            tooltip: {
              enterable: true,
              show: true,
              trigger: 'axis',
              triggerOn: 'mousemove',
              appendToBody: true,
              confine: true,
              textStyle: {
                align: 'left',
                fontSize: 7,
              },

              formatter: function(params) {
                // console.log(params);
                let str = '';
                params.forEach((item, idx) => {
                  str += `${item.data.time}： ${item.data.value}`;
                });
                return str;
              },
            },

            grid: {
              top: 30,
              left: 55,
              right: 0,
              bottom: 45,
            },
            dataZoom: [
              {
                height: 44,
                bottom: 0,

                handleSize: '50%',
                handleStyle: {
                  color: '#d3dee5',
                },
                textStyle: {
                  color: '#000',
                },
              },
              {
                type: 'inside',
                start: 0,
                end: 0,
              },
            ],

            xAxis: [
              {
                type: 'category',
                show: true,
                data: waterTimer,
                boundaryGap: true,
                name: '时间/数值',
                nameRotate: 50,
                nameLocation: 'start',
                nameGap: '18',

                axisLabel: {
                  interval: 1,
                  rotate: 45,
                  formatter: function(value) {
                    // console.log(value);
                    let val = value?.slice(11, 20);
                    return val;
                  },
                },
              },
            ],
            yAxis: [
              {
                type: 'category',
                boundaryGap: true, // 从最左端开始
                show: true,
              },
            ],
            series: [
              {
                color: 'rgba(63, 64, 72, 1)',
                showAllSymbol: true, //标注所有数据点
                symbol: 'circle',
                type: 'line',
                data: this.waterList[i].info,
              },
            ],
          };
          //使用刚指定的配置项和数据显示图表
          myWaterSystemMonitorLineChart.setOption(optoins);
          window.addEventListener('resize', function(e) {
            waterSystemMonitorLineChart.resize();
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  // overflow: auto;
  .WaterSystem {
    padding-right: 5px;
    display: flex;
  }
}

.right {
  width: 100%;
  height: 288px;
  border-radius: 2px;
  margin-left: 15px;
  // margin-top: 29px;
  .topTitle {
    margin-bottom: 4px;
    width: 100%;
    height: 30%;
    /** 文本1 */
    font-size: 16px;
    font-weight: 400;

    letter-spacing: 2px;
    color: rgba(42, 43, 49, 1);
    text-align: left;
    margin-left: 10px;
  }
  .top {
    height: 20%;
    display: flex;
    flex-direction: column;
    width: 100%;

    .botContent {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .CRTbtn {
        // **文本1 */
        font-size: 9px;
        font-weight: 400;
        letter-spacing: 0.45px;
        color: rgba(167, 164, 168, 1);
        margin: 10px 5px;
        margin-left: 10px;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .activeCss {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        // **文本1 */
        color: #000;
        font-size: 14px;
      }
    }
  }
}
.line {
  width: 100%;
  height: 100%;

  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .noData {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    font-size: 0.89rem;
    color: #666666;
    text-align: center;
    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
    font-weight: 400;
  }
  .WaterSystemEchart {
    width: 100%;
    height: 70px;
    border-bottom: 1px solid rgba(234, 232, 235, 1);
    margin: 5px auto;
    > &:not(:last-child) {
      border-bottom: 1px solid rgba(234, 232, 235, 1);
    }
  }
}

.flex {
  width: 100%;
  height: 100%;
}
/*定义滑块 内阴影+圆角*/
.line::-webkit-scrollbar-thumb {
  border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 6px rgb(159, 158, 158);
  background-color: rgb(188, 187, 187);
  cursor: pointer !important;
}
.line::-webkit-scrollbar {
  width: 7px;
  height: 3px;
  background-color: #f5f5f5;
  cursor: pointer;
}
/* 悬浮放大滚动滑块 */
.line::-webkit-scrollbar-thumb:hover {
  background: #a3a2a2;
  /*这里默认裁剪到border-box，以下使用shadow代替了边框大小*/
  border-width: 0;

  box-shadow: inset 3px 3px 3px hsl(0deg 0% 100% / 25%), inset -3px -3px 3px rgb(0 0 0 / 25%);
}
// 悬浮到滚动条所在位置上显示
.line::-webkit-scrollbar-thumb {
  background-color: #2e2e2e;
  border-radius: 12px;
  /* padding-box 表示背景裁剪到内边距框，
      这里也可以用content-box,表示裁剪到内容框，
      默认为border-box，表示裁剪到边框*/
  background-clip: padding-box;
  border-style: solid;
  border-width: 2px;
  border-color: transparent;
}
</style>
